<script>
  export let count = 5;
  export let dotSize = 20;
  export let gap = 10;
  export let visible = false;
</script>

{#if visible}
  <div class="loadingBackground" style="gap: {gap}px">
    {#each Array(Number(count)) as _, i}
      <div class="dot" style="animation-delay: {i/count/2}s; width: {dotSize}px; height: {dotSize}px;" />
    {/each}
  </div>
{/if}

<style>
  .loadingBackground {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .dot {
    border-radius: 50%;
    background-color: transparent;
    -webkit-animation: pulsate 1s ease-in infinite;
    -moz-animation: pulsate 1s ease-in infinite;
    -ms-animation: pulsate 1s ease-in infinite;
    -o-animation: pulsate 1s ease-in infinite;
    animation: pulsate 1s ease-in infinite;
  }

  @-webkit-keyframes pulsate {
      0% { background-color: #222; transform: scale(0.3); }
     50% { background-color: #000; transform: scale(1); }
    100% { background-color: #222; transform: scale(0.3);
    }
  }

  @-moz-keyframes pulsate {
      0% { background-color: #222; transform: scale(0.3); }
     50% { background-color: #000; transform: scale(1); }
    100% { background-color: #222; transform: scale(0.3); }
  }

  @-o-keyframes pulsate {
      0% { background-color: #222; transform: scale(0.3); }
     50% { background-color: #000; transform: scale(1); }
    100% { background-color: #222; transform: scale(0.3); }
  }

  @keyframes pulsate {
      0% { background-color: #222; transform: scale(0.3); }
     50% { background-color: #000; transform: scale(1); }
    100% { background-color: #222; transform: scale(0.3); }
  }
</style>